// extracted by mini-css-extract-plugin
export default {"content":"Rv1aR","sportContainer":"Gnqei"};